/* Toont alleen de productfoto's van de gekozen kleur.
   Foto's met een optiewaarde (bijv. "Rood") in de alt-tekst horen bij die waarde.
   Foto's zonder optiewaarde in de alt-tekst blijven altijd zichtbaar. */
(function () {
  function norm(s) {
    return (s || '').toString().toLowerCase();
  }

  function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function mentions(alt, value) {
    return new RegExp('(^|[^a-z0-9])' + escapeRegExp(value) + '([^a-z0-9]|$)').test(alt);
  }

  function applyColorFilter(selectedOptions) {
    var gallery = document.querySelector('product-info media-gallery');
    var selected = (selectedOptions || []).map(norm);
    if (!gallery || !selected.length) return;

    var allValues = (window.colorGalleryValues || [])
      .reduce(function (acc, values) {
        return acc.concat(values);
      }, [])
      .map(norm)
      .filter(Boolean);

    function isVisible(alt) {
      alt = norm(alt);
      var found = allValues.filter(function (value) {
        return mentions(alt, value);
      });
      if (!found.length) return true;
      return found.some(function (value) {
        return selected.indexOf(value) !== -1;
      });
    }

    var count = 0;
    var firstVisibleId = null;
    var activeHidden = false;

    gallery.querySelectorAll('[id^="GalleryViewer"] li[data-media-id]').forEach(function (li) {
      var img = li.querySelector('img');
      var show = isVisible(img && img.alt);
      li.style.display = show ? '' : 'none';
      if (show) {
        count++;
        if (!firstVisibleId) firstVisibleId = li.dataset.mediaId;
      } else if (li.classList.contains('is-active')) {
        activeHidden = true;
      }
    });

    gallery.querySelectorAll('[id^="GalleryThumbnails"] li[data-target]').forEach(function (li) {
      var img = li.querySelector('img');
      li.style.display = isVisible(img && img.alt) ? '' : 'none';
    });

    gallery.querySelectorAll('.slider-counter--total').forEach(function (el) {
      el.textContent = count;
    });

    gallery.querySelectorAll('slider-component').forEach(function (slider) {
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });

    if (activeHidden && firstVisibleId && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(firstVisibleId, true);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyColorFilter(window.colorGalleryInitial);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && variant.options) {
          setTimeout(function () {
            applyColorFilter(variant.options);
          }, 0);
        }
      });
    }
  });
})();
